import './PopupPublicatie.scss';
import { SharePage } from '../../../SharePage/SharePage';
import { AiOutlineClose, AiOutlineDownload } from 'react-icons/ai';
export const PopupPublicatie = ({ closePopupHandler, ...props }) => {
    return <div className="c-detail-fiche--publications">
        <div className="c-detail-fiche--publications__header">
            <div className="popupClosingIconContainer" onClick={() => closePopupHandler()}>
                <AiOutlineClose className="popupClosingIcon" />
            </div>
            {
                props.data?.detailBannerVideo ? <div dangerouslySetInnerHTML={{__html: props.data?.detailBannerVideo}}></div>
                    : props.data?.detailImage && <img src={props.data.detailImage.url} alt={props.data.detailImage.alt} />
            }
        </div>
        <div className="c-detail-fiche--publications__body">
            <div className="c-detail-fiche--publications__body__title">
                <h2>{props.data.title}</h2>
            </div>
            <div className="c-detail-fiche--publications__body__info">
                {
                    props.data?.detailSideBar && <ul>
                        {/* Autor, publication date, Source */}
                        {
                            props.data.detailSideBar?.author && <li>
                                <span className="c-detail-fiche--publications__body__info__label">Auteur</span>
                                <span className="c-detail-fiche--publications__body__info__value">{props.data.detailSideBar.author}</span>
                            </li>
                        }
                        {
                            props.data.detailSideBar?.publicationDate && <li>
                                <span className="c-detail-fiche--publications__body__info__label">Publicatiedatum</span>
                                <span className="c-detail-fiche--publications__body__info__value">{props.data.detailSideBar.publicationDate}</span>
                            </li>
                        }
                        {
                            props.data.detailSideBar.source && (props.data.detailSideBar?.sourceUrl?.url ? <li>
                                <span className="c-detail-fiche--publications__body__info__label">Bron</span>
                                <span className="c-detail-fiche--publications__body__info__value">
                                    <a href={props.data.detailSideBar?.sourceUrl?.url} target={props.data.detailSideBar?.sourceUrl?.target} className="c-detail-fiche--publications__body__info__link">
                                        {props.data.detailSideBar.source}
                                    </a>
                                </span>
                            </li>
                                : <li>
                                    <span className="c-detail-fiche--publications__body__info__label">Bron</span>
                                    <span className="c-detail-fiche--publications__body__info__value">{props.data.detailSideBar.source}</span>
                                </li>)
                        }
                    </ul>
                }
            </div>
            <div className="c-detail-fiche--publications__body__description">
                <div dangerouslySetInnerHTML={{ __html: props.data.detailBody?.content }}></div>
            </div>
            <div className="c-detail-fiche--publications__body__share">
                <div className="row">
                    <div className="col-md-6 col-12">
                        <div className="download">
                            {
                                props.data.detailBody?.download?.title &&
                                <a href={props.data.detailBody.download?.url} className="c-button c-button--block" target={props.data.detailBody.download.target}>
                                    {props.data.detailBody.download?.title} <i class="fa-regular fa-arrow-up-right-from-square"></i>
                                </a>
                            }
                        </div>
                    </div>
                    <div className="col-md-6 col-12">
                        <span className='c-detail-fiche--publications__body__share__social'>
                            <SharePage shareTitle={props.data.title} />
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>;
}


// const PopupPublicatieSideBar = (props) => {
//     return props.data.detailSideBar &&
//         <div className="bottom">
//             {
//                 props.data.detailSideBar.author &&

//                 <div className="info">
//                     <p className="title">
//                         Autheur
//                     </p>
//                     <p>
//                         {props.data.detailSideBar.author}
//                     </p>
//                 </div>
//             }
//             {
//                 props.data.detailSideBar.theme &&
//                 <div className="info">
//                     <p className="title">
//                         Thema
//                     </p>
//                     <p>
//                         {props.data.detailSideBar.theme}
//                     </p>
//                 </div>
//             }
//             {
//                 props.data.detailSideBar.subTheme &&
//                 <div className="info">
//                     <p className="title">
//                         Subthema
//                     </p>
//                     <p>
//                         {props.data.detailSideBar.subTheme}
//                     </p>
//                 </div>
//             }
//             {
//                 props.data.detailSideBar.publicationDate &&
//                 <div className="info">
//                     <p className="title">
//                         Publicatiedatum
//                     </p>
//                     <p>
//                         {props.data.detailSideBar.publicationDate}
//                     </p>
//                 </div>
//             }
//             {
//                 props.data.detailSideBar.sourceUrl &&
//                 <div className="info">
//                     <p className="title">
//                         Bron
//                     </p>
//                     <p>
//                         <a href={`http://${props.data.detailSideBar.sourceUrl.url}`} target={props.data.detailSideBar.sourceUrl.title}>{props.data.detailSideBar.sourceUrl.title}</a>
//                     </p>
//                 </div>
//             }
//         </div>;
// }

// const PopupPublicatieBody = (props) => {
//     return <div className="inner">
//         {props.data.detailBody &&
//             <div dangerouslySetInnerHTML={{ __html: props.data.detailBody.content }}></div>
//         }
//         <div className="download">
//             {
//                 props.data.detailBody && props.data.detailBody.download &&
//                 <a href={props.data.detailBody.download.url} className="c-button c-button--block">
//                     {props.data.detailBody.download.title}
//                 </a>
//             }
//         </div>
//         <SharePage shareTitle={props.data.title} />
//     </div>;

// }
